export enum PushNotificationErrorType {
  PERMISSION_ERROR = "PERMISSION_ERROR",
  TOKEN_ERROR = "TOKEN_ERROR",
  DELIVERY_FAILURE = "DELIVERY_FAILURE",
  UNKNOWN = "UNKNOWN",
}

export class PushNotificationError extends Error {
  public name: string;
  public type: PushNotificationErrorType;

  constructor(type: PushNotificationErrorType, message: string) {
    super(message);
    this.name = "PushNotificationError";
    this.type = type;
  }
}
